export default "/assets/images/carbon-filter.png?d5f92544036da43551de54a295585c2b";